module.exports = __webpack_public_path__ + "img/taken.a905a4ab.png";